import { useTheme } from 'styled-components';
import {
  Amount,
  Asset,
  AssetIcon,
  Value,
  WalletContainer,
  BodyLoaderWrapper,
  HeaderLoader,
  HeaderLine,
  BodyLine,
  AssetName,
  AssetCode,
  AmountInUsd,
  AssetAmount,
  AssetValue,
  Action,
  ActionButton,
  SecondAction,
  ThirdAction,
  FirstAction,
} from './styles';

export const WalletLoader = () => {
  const { colors } = useTheme();
  return (
    <WalletContainer>
      <HeaderLoader>
        <Asset />
        <Amount />
        <Value />
        <Action />
        <HeaderLine />
      </HeaderLoader>
      {[...Array(4)].map((item, i) => {
        return (
          <BodyLoaderWrapper
            key={i}
            backgroundColor={colors.surface.interactiveDefault}
            foregroundColor={colors.surface.pressed}
          >
            <AssetIcon />
            <AssetName />
            <AssetCode />
            <AmountInUsd />
            <AssetAmount />
            <AssetValue />
            <ActionButton />
            <FirstAction />
            <SecondAction />
            <ThirdAction />
            <BodyLine />
          </BodyLoaderWrapper>
        );
      })}
    </WalletContainer>
  );
};
